export const LOADING = 'LOADING';
export const ERROR = 'ERROR';

export const LOGIN_SUCCEED = 'LOGIN_SUCCEED';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const USER_LOGOUT = 'USER_LOGOUT';

export const REGISTER_SUCEED = 'REGISTER_SUCEED';
export const REGISTER_LOADING = 'REGISTER_LOADING';
export const REGISTER_FAILED = 'REGISTER_FAILED';

export const FETCH_CART_LOADING = 'FETCH_CART_LOADING';
export const FETCH_CART_SUCCEED = 'FETCH_CART_SUCCEED';
export const FETCH_CART_FAILED = 'FETCH_CART_FAILED';
export const ADD_PRODUCT_TO_CART_BY_ID = 'ADD_PRODUCT_TO_CART_BY_ID';

export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_PRODUCTS_LOADING = 'FETCH_PRODUCTS_LOADING';
export const FETCH_PRODUCTS_SUCCEED = 'FETCH_PRODUCTS_SUCCEED';
export const FETCH_PRODUCTS_FAILED = 'FETCH_PRODUCTS_FAILED';
export const FETCH_PRODUCTS_BY_KEYWORDS = 'FETCH_PRODUCTS_BY_KEYWORDS';

export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
export const HANDLE_CHECKOUT_FORM = 'HANDLE_CHECKOUT_FORM';
export const RESET_CHECKOUT_FORM = 'RESET_CHECKOUT_FORM';
export const SUBMIT_SHIPPING_ADDRESS_SUCCEED = 'SUBMIT_SHIPPING_ADDRESS_SUCCEED';
export const SUBMIT_SHIPPING_ADDRESS_LOADING = 'SUBMIT_SHIPPING_ADDRESS_LOADING';
export const SUBMIT_SHIPPING_ADDRESS_FAILED = 'SUBMIT_SHIPPING_ADDRESS_FAILED';
export const SUBMIT_SHIPPING_OPTIONS_SUCCEED = 'SUBMIT_SHIPPING_OPTIONS_SUCCEED';
export const SUBMIT_SHIPPING_OPTIONS_LOADING = 'SUBMIT_SHIPPING_OPTIONS_LOADING';
export const SUBMIT_SHIPPING_OPTIONS_FAILED = 'SUBMIT_SHIPPING_OPTIONS_FAILED';
export const SUBMIT_ORDER_SUCCEED = 'SUBMIT_ORDER_SUCCEED';
export const SUBMIT_ORDER_LOADING = 'SUBMIT_ORDER_LOADING';
export const SUBMIT_ORDER_FAILED = 'SUBMIT_ORDER_FAILED';
export const LEAVE_CHECKOUT_PAGE = 'LEAVE_CHECKOUT_PAGE';

export const FETCH_ORDERS_LOADING = 'FETCH_ORDERS_LOADING';
export const FETCH_ORDERS_SUCCEED = 'FETCH_ORDERS_SUCCEED';
export const FETCH_ORDERS_FAILED = 'FETCH_ORDERS_FAILED';

export const FETCH_PRODUCT_DETAIL_LOADING = 'FETCH_PRODUCT_DETAIL_LOADING';
export const FETCH_PRODUCT_DETAIL_SUCCEED = 'FETCH_PRODUCT_DETAIL_SUCCEED';
export const FETCH_PRODUCT_DETAIL_FAILED = 'FETCH_PRODUCT_DETAIL_FAILED';

export const HANDLE_REVIEW_FORM = 'HANDLE_REVIEW_FORM';
export const SUBMIT_REVIEW_LOADING = 'SUBMIT_REVIEW_LOADING';
export const SUBMIT_REVIEW_SUCCEED = 'SUBMIT_REVIEW_SUCCEED';
export const SUBMIT_REVIEW_FAILED = 'SUBMIT_REVIEW_FAILED';
export const RESET_REVIEW_FORM = 'RESET_REVIEW_FORM';
export const SET_CURRENT_EDIT_ID = 'SET_CURRENT_EDIT_ID';
export const LEAVE_PRODUCT_DETAIL_PAGE = 'LEAVE_PRODUCT_DETAIL_PAGE';